import { render, staticRenderFns } from "./AdminPermissionsDialog.vue?vue&type=template&id=4d0c8912&scoped=true&"
import script from "./AdminPermissionsDialog.vue?vue&type=script&lang=js&"
export * from "./AdminPermissionsDialog.vue?vue&type=script&lang=js&"
import style0 from "./AdminPermissionsDialog.vue?vue&type=style&index=0&id=4d0c8912&scoped=true&lang=css&"
import style1 from "./AdminPermissionsDialog.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d0c8912",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAlert } from 'vuetify/lib/components/VAlert';
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VBtnToggle } from 'vuetify/lib/components/VBtnToggle';
import { VCard } from 'vuetify/lib/components/VCard';
import { VChip } from 'vuetify/lib/components/VChip';
import { VDialog } from 'vuetify/lib/components/VDialog';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VList } from 'vuetify/lib/components/VList';
import { VListItem } from 'vuetify/lib/components/VList';
import { VListItemContent } from 'vuetify/lib/components/VList';
import { VListItemTitle } from 'vuetify/lib/components/VList';
import { VSelect } from 'vuetify/lib/components/VSelect';
import { VSheet } from 'vuetify/lib/components/VSheet';
import { VSpacer } from 'vuetify/lib/components/VGrid';
import { VSwitch } from 'vuetify/lib/components/VSwitch';
installComponents(component, {VAlert,VBtn,VBtnToggle,VCard,VChip,VDialog,VIcon,VList,VListItem,VListItemContent,VListItemTitle,VSelect,VSheet,VSpacer,VSwitch})
